'use strict';

export { default as DataEventSocket } from './socket/data-event-socket-stomp';





// WEBPACK FOOTER //
// ./js/data-event-socket-portlet.js